import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSetting } from '../../hooks/useSetting';
import { useId } from '../../hooks/useId';
import { Toggle } from '../Common/Toggle';
import { Button } from '../Common/Button';
import { createUseStyles } from 'react-jss';
import backgroundImage from '../../assets/images/background.png';


export const settingsViewKey = 'settings';

export interface ISettingsViewProps {
    onShowMenu(): void;
}

const useStyles = createUseStyles({
    root: {
        backgroundImage: `url(${backgroundImage})}`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100%',
        height: '100%',
        position: 'relative',
    },
    block: {
        position: 'absolute',
        left: '5%',
        top: '5%',
    },
});

export const SettingsView: React.FunctionComponent<ISettingsViewProps> = props => {
    const { t } = useTranslation();
    const styles = useStyles();

    const [ showPaw, setShowPaw ] = useSetting('showPaw', true);
    const [ playMusic, setPlayMusic ] = useSetting('playMusic', true);
    const [ musicVolume, setMusicVolume ] = useSetting('musicVolume', 20);

    const pawToggleId = useId('toggle');
    const audioToggleId = useId('music');
    const musicVolumeId = useId('volume');

    const handleMusicVolumeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setMusicVolume(Number(event.target.value));
    };

    return (
        <div className={styles.root}>
            <div className={styles.block}>
                <h1>{t('settings.title')}</h1>
                <div>
                    <Toggle id={pawToggleId} checked={showPaw} onChange={setShowPaw}/>
                    <label htmlFor={pawToggleId}>Paw</label>
                </div>
                <div>
                    <Toggle id={audioToggleId} checked={playMusic} onChange={setPlayMusic}/>
                    <label htmlFor={audioToggleId}>Audio</label>
                </div>
                <div>
                    <input type="range" min="1" max="100" value={musicVolume} onChange={handleMusicVolumeChange} id={musicVolumeId} />
                    <label htmlFor={musicVolumeId}>Music volume</label>
                </div>
                <Button onClick={props.onShowMenu}>{t('back')}</Button>
            </div>
        </div>
    );
};
